export const isLoading = state => state.adminReducer.institution.isLoading

export const isSuccess = state => state.adminReducer.institution.isSuccess

export const institution = state => state.adminReducer.institution.institution

export const permissions = state => state.adminReducer.institution.permissions

export const options = state => state.adminReducer.institution.options
